import { lazy } from "react";

const CreateQAPage = lazy(() => import("./create"));
const QAListPage = lazy(() => import("./main"));
const UpdateQAPage = lazy(() => import("./update"));

export {
  CreateQAPage, QAListPage, UpdateQAPage,
};
